import { render, staticRenderFns } from "./PayWays.vue?vue&type=template&id=299082ae&scoped=true&"
import script from "./PayWays.vue?vue&type=script&lang=js&"
export * from "./PayWays.vue?vue&type=script&lang=js&"
import style0 from "./PayWays.vue?vue&type=style&index=0&id=299082ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299082ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299082ae')) {
      api.createRecord('299082ae', component.options)
    } else {
      api.reload('299082ae', component.options)
    }
    module.hot.accept("./PayWays.vue?vue&type=template&id=299082ae&scoped=true&", function () {
      api.rerender('299082ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PayWays/PayWays.vue"
export default component.exports